export const TimeStampToDate = (timeStamp) => {
    var lastUpdateStr = String(new Date(timeStamp))
    if (lastUpdateStr !== "Invalid Date") {
        return lastUpdateStr.replace("GMT+0530 (India Standard Time)", "")
    }
    else {
        return ""
    }
}